import React, { useState } from "react";
import { stringToDate, dateToString, addDays } from "../../services/dateTimeFormat";
import OriginalDatePicker, {
  registerLocale
  // ,setDefaultLocale
} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import de from "date-fns/locale/de";

registerLocale("de", de);

const DatePicker = ({
  name,
  label,
  value,
  error,
  help,
  onSimpleChange,
  disabled,
  ...rest
}) => {
  const [date, setDate] = useState(stringToDate(value, "dd.MM.yyyy"));

  const ExampleCustomInput = ({ value, onClick }) => (
    <button
      className="example-custom-input"
      onClick={onClick}
      disabled={disabled ? disabled : null}
    >
      {value}
    </button>
  );

  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <div>
        <OriginalDatePicker
          selected={date}
          locale="de"
          shouldCloseOnSelect={true}
          onChange={newDate => {
            setDate(newDate);
            onSimpleChange({
              name: name,
              value: dateToString(newDate, "dd.MM.yyyy")
            });
          }}
          disabled={disabled ? disabled : null}
          dateFormat="dd.MM.yyyy"
          minDate={addDays(new Date(), -5)}
          {...rest}
          customInput={<ExampleCustomInput />}
        />
      </div>
      {help && (
        <small id={`${name}Help`} className="form-text text-muted">
          {help}
        </small>
      )}
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};
export default DatePicker;
